import { useAccountStore } from "@/stores/account.store";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import LoadingPage from "../utils/loading.page";

export function CallbackPage() {
  const { accountSnapshot, accountProxy } = useAccountStore();

  useEffect(() => {
    accountProxy.completeLogin();
  }, []);

  if (accountSnapshot.isLogged) {
    return <Navigate to="/" />;
  }

  return <LoadingPage />;
}

export default CallbackPage;
